import React from "react";
import { cn } from "../../../util/general";

const variants = {
  primary: "bg-primary text-white",
  outline: "bg-transparent border border-primary text-primary",
};

const Button = ({ className, children, variant = "primary", ...props }) => {
  return (
    <button
      className={cn(
        "flex items-center justify-center text-sm gap-1 px-6 py-1.5 text-center !capitalize transition duration-200 ease-in-out rounded-full cursor-pointer active:scale-95 focus:outline-none shadow-regular",
        variants[variant],
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
